import * as fieldset from './fieldset';

export default {
  title: 'Edit Blog Post',
  elements: [
    {
      title: 'Main',
      type: 'editForm',
      config: {
        actions: {
          fetch: {
            endpoint: 'blog-posts/{id}',
            method: 'GET',
            dataPath: 'data',
            transform: values => {
              return {
                ...values,
                content: values.content || []
              };
            }
          },
          save: {
            endpoint: 'blog-posts/{id}',
            method: 'PUT'
          }
        },
        fieldsets: [fieldset.main]
      }
    }
  ]
};
